import axios from "axios";
// import { decrypt } from "dotenv";
 import { toast } from "react-toastify";
// import CryptoJS from "crypto-js";
import {decryptData, encryptData} from "../../Componenets/Common/Encrypt-Decrypt"
import { GET_AVAILABLE_BALANCE, GET_PAYMENT_DETAILS, GET_REFUND_DETAILS, GET_SETTLEMENT_DETAILS, GET_SETTLEMENT_DETAILS_BY_MONTH } from "../../Store/Type";
import { GET_REFUND_REQUEST ,GET_USER,GET_NUMBER,GET_COMMISSION,GET_COMMISSION_SEARCH,GET_RAZORPAY_DETAILS} from "../../Store/Type";

const api = axios.create({
  headers: {
    "Content-Type": "application/json",
  },
});
const apiUrl = process.env.REACT_APP_API_URL;


export const GetPayDashDetails = async (dispatch, setSpinning) => {
  try {
    const response = await api.get(`${apiUrl}/checkavailBalance`);
    console.log(response?.data?.availablebalance, "pay response");
    const availablebalance = decryptData(response?.data?.availablebalance);
    console.log(availablebalance);
    
    console.log(availablebalance, "Payment dashboard response");
    dispatch({ type: GET_AVAILABLE_BALANCE, payload: availablebalance });
    return availablebalance;
  } catch (error) {
    console.log(error, "error fetching payments dashboard details");
  } finally {
    setSpinning && setSpinning(false);
  }
};

export const GetPaymentDetails = async (count,skip,dispatch,setSpinning) => {
  const payload = {
    count:count,
    skip:skip,
  }
  try {
    console.log(payload,"payload")
    const response = await axios.post(`${apiUrl}/razorpay-payments`, payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
    })
    console.log(response.data.data.items, "payment response");
    const paymentDetails = response.data.data.items
    dispatch({type: GET_PAYMENT_DETAILS, payload: paymentDetails})
    return paymentDetails;
  } catch (error) {
    console.log(error, "error fetching payment details");
  } finally {
    setSpinning && setSpinning(false);
  }
};

export const GetSettlementDetails = async (count,skip,dispatch,setSpinning) => {
  const payload = {
    count: count,
    skip: skip,
  }
  try {
    console.log(payload,"payload")
    const response = await axios.post(`${apiUrl}/razorpay-settlement`, payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
    })
    console.log(response.data.data.items, "settlement response");
    const settlementDetails = response.data.data.items
    dispatch({type: GET_SETTLEMENT_DETAILS, payload: settlementDetails})
    return settlementDetails;
  } catch (error) {
    console.log(error, "error fetching settlement details");
  } finally {
    setSpinning && setSpinning(false);
  }
};

export const GetSettlementByMonth=async(dispatch,setSpinning,month,year)=>{
  try{
    const response=await axios.post(`${apiUrl}/razorpay/settlement/yearandmonth`,
    
      {
        
    year : year,
    month : month,

      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
    //  const responsedata=(response.data).slice(0,10)
     dispatch({ type: GET_SETTLEMENT_DETAILS_BY_MONTH, payload: response.data });
     console.log(response.data, "date response");
  }
  catch (err) {
    console.log(err, "date error");
  }finally {
    setSpinning && setSpinning(false);
  }
}

export const GetRefundDetails = async (count,skip,dispatch,setSpinning) => {
  const payload = {
    count: count,
    skip: skip,
  }
  try {
    console.log(payload,"payload")
    const response = await axios.post(`${apiUrl}/razorpay-refund`, payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
    })
    console.log(response.data.data.items, "refund response");
    const refundDetails = response.data.data.items
    dispatch({type: GET_REFUND_DETAILS, payload: refundDetails})
    return refundDetails;
  } catch (error) {
    console.log(error, "error fetching refund details");
  } finally {
    setSpinning && setSpinning(false);
  }
};
export const GetRefundRequestDetails = async (
  dispatch,
  setSpinning,
  device_id
) => {
  try {
    const response = await api.get(
      `${apiUrl}/refund/requested/details/${device_id}`
    );
    console.log(response.data, "cancellation response");
    dispatch({ type: GET_REFUND_REQUEST, payload: response.data });
    return response.data;
  } catch (err) {
    console.log(err, "error fetching cancellation details");
  } finally {
    setSpinning && setSpinning(false);
  }
};


export const handlePaymentsearch = async (value, dispatch,setSpinning) => {
  try {
    if (value) {
      const searchTerm = value;
      console.log(searchTerm, "search term");
      const response =
        searchTerm.trim().length === 0 && searchTerm.trim().length>=20
          ? await axios.get(`${apiUrl}/razorpay-payments/$`)
          : await axios.get(`${apiUrl}/razorpay/PaymentDetailsById/${searchTerm}`);
      
      
      dispatch({ type: GET_PAYMENT_DETAILS, payload: response.data});
      console.log("pAYMENT",response.data)
      return response ;
    } else{
      GetPaymentDetails(10, 0, dispatch, setSpinning);
    }
  } catch (error) {
    handleError(error);
    return null;
  }finally{
    setSpinning(false)
  }
};
export const handleSettlementsearch = async (value, dispatch,setSpinning) => {
  try {
    if (value) {
      const searchTerm =value;
      console.log(searchTerm, "search term");
      const response =
        searchTerm.trim().length === 0
          ? await axios.get(`${apiUrl}/razorpay-settlement/$`)
          : await axios.get(`${apiUrl}/razorpay/SettlementDetailsById/${searchTerm}`);
      dispatch({ type: GET_SETTLEMENT_DETAILS, payload: response.data });
      return response.data;
    }else{
      GetSettlementDetails(10, 0, dispatch, setSpinning);
    }
  } catch (error) {
    handleError(error);
    return null;
  }finally{
    setSpinning(false)
  }
};
export const handleRefundsearch = async (value, dispatch,setSpinning) => {
  try {
    if (value) {
      const searchTerm = value;
      console.log(searchTerm, "search term");
      const response =
        searchTerm.trim().length === 0
          ? await axios.get(`${apiUrl}/razorpay-refund/$`)
          : await axios.get(`${apiUrl}/razorpay/RefundDetailsById/${searchTerm}`);
      dispatch({ type: GET_REFUND_DETAILS, payload: response.data });
      return response.data;
    } else{
      GetRefundDetails(10, 0, dispatch, setSpinning);
    }
  } catch (error) {
    handleError(error);
    return null;
  }finally{
    setSpinning(false)
  }
};
export const handleRefundRequestNormal=async(value)=>{
  console.log(" valuesAPI Payid:", value.pay_id);
  console.log(" valuesAPI Amount:", value.amount);
  const payload = {
     pay_id:encryptData(value.pay_id) ,
     amount:encryptData(value.amount), 
  }
 
  try{
    console.log(payload,"payloadPayment")
    const response = await api.post(
      `${apiUrl}/razorpay/normal/refund`,payload,
       {
      headers: {
        "Content-Type": "application/json",
      },
    }
    );
   
   
    console.log(response,"handleRefundRequestNormal")
    
  }
  catch (error) {
    handleError(error);
    return null;
  }
}
// export const handleRefundRequestStatus=async(value)=>{
  
//   const ticketNo=value.ticket_no
  
//   try{
    
//     const response=await api.put(`${apiUrl}/update/Refund/status/${ticketNo}`);
    

//     console.log(response,"handleRefundRequestNormal")
    
//   }
//   catch (error) {
//     handleError(error);
//     return null;
//   }
// }

export const handleRefundRequestDetailsSearch = async (inputValue, dispatch,setSpinning) => {
  try {
    if (inputValue) {
      const searchTerm = inputValue;
      const response =
        searchTerm.trim().length === 0
          ? await axios.get(`${apiUrl}/searchcancellationhistory/$`)
          : await axios.get(
              `${apiUrl}/searchcancellationhistory/${searchTerm}`
            );

      dispatch({ type: GET_REFUND_REQUEST, payload: response.data });
      // return response.data[0];
    } 
  } catch (error) {
    handleError(error);
    return null;
  }finally{
    setSpinning(false)
  }
};


export const handleGetUser=async(dispatch)=>{
  try {
      const response = await axios.get(`${apiUrl}/authenticateMobileNuber`); // Replace with your API endpoint
       console.log(response.data.authendicateNumber,"responses")
       dispatch({ type: GET_USER, payload: response.data.authendicateNumber });
    } catch (error) {
      console.error('Error fetching mobile number:', error);
    }
}

export const handleGetUserNumber=async(dispatch,user_id)=>{
  try {
      const response = await axios.get(`${apiUrl}/get/authenticater/data/${user_id}`); // Replace with your API endpoint
      dispatch({ type: GET_NUMBER, payload: response.data.authendicationData.mobile_number });
       console.log(response.data.authendicationData.mobile_number,"responses")
       
      //  dispatch({ type: GET_USER, payload: response.data.authendicationData });
    } catch (error) {
      console.error('Error fetching mobile number:', error);
    }
}

export const handleGetOtp=async(value)=>{


const generateOtp = Math.floor(100000 + Math.random() * 900000).toString();

sessionStorage.setItem("refundOtp",generateOtp)

  console.log(generateOtp,"oootp")
  const payload={
  
    mobile:encryptData(value.userNumber),
    otp:encryptData(generateOtp),
}
  try{
    const response=await axios.post(`${apiUrl}/refundUpdateSms`,payload,
      {
      headers: {
        "Content-Type": "application/json",
      }
  });
  toast.success(response.message);
    console.log(response,"OTP Response")
  }catch (error) {
      console.error('Error fetching mobile number:', error);
    }
}

export const handleOTPVerify=async(value)=>{
  const payload={
    ticket_no:value.ticket_no,
    verify_user:value.userName,
    verify_number:value.userNumber,
  }
  try{
    const response=await axios.put(`${apiUrl}/updateRefundStatus`,payload);
    toast.success(response.data.message)
    console.log(response.data.message,"OTP Response Success")
    return response.data.message
    
  }catch (error) {
      console.error('Error fetching :', error);
    }

}

export const handleCommission=async(dispatch)=>{
  try{
    const response=await axios.get(`${apiUrl}/calculate-Profit-Or-Loss`);
     dispatch({ type: GET_COMMISSION, payload: response.data});
    console.log(response.data,"Commission Response")
  }catch(error){
    console.error('Error Fetching in Commission:',error)
  }
}


export const handleCommissionSearch = async (e, dispatch,setSpinning) => {
  try {
    if (e) {
      const searchTerm = e
      console.log(searchTerm, "search term");
      const response =await axios.get(`${apiUrl}/search/profit/and/loss/${searchTerm}`)
      console.log(response.data, "searched data");
      dispatch({ type: GET_COMMISSION, payload: response.data });
      return response.data
    } else {
      handleCommission(dispatch);
    }
  } catch (error) {
    // handleError(error);
    console.log(error, "error searching data");
    return null;
  }finally{
    setSpinning(false)
  }
};

export const GetRazorpayDetails = async (
  dispatch,
  setSpinning,
  setLoad,
  fromDate,
  toDate,
  filter,
) => {
  try {
    // const response = await api.get(`${apiUrl}/filter-by-date`)
console.log(fromDate,toDate,filter,"checkdates")
    const response = await axios.post(
      `${apiUrl}/razorpay/dashboard/stats`,
      {
        from_date: fromDate,
        to_date: toDate,
        duration: filter,
      },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    dispatch({ type: GET_RAZORPAY_DETAILS, payload: response.data });

    console.log(response.data, "dashboard response Razorpay");
  } catch (err) {
    console.log(err, "error fetching dashboard response");
  } finally {
        setSpinning(false);
        setLoad(false);
      }
};

const handleError = (error) => {
  console.error("Error details:", error);
  let errorMessage = "An error occurred";

  if (error.response) {
    console.error("Error response from server:", error.response);
    errorMessage = `Server responded with status ${error.response.status}`;
  } else if (error.request) {
    console.error("No response received:", error.request);
    errorMessage = "No response received from server";
  } else {
    console.error("Error setting up request:", error.message);
    errorMessage = error.message;
  }

  if (error.code === "ERR_NETWORK") {
    errorMessage =
      "Network Error: Unable to connect to the server. Please check the server status and your network connection.";
  }
  if (error.code === "ERR_CONNECTION_REFUSED") {
    errorMessage =
      "Network Error: Unable to connect to the server. Please check the server status and your network connection.";
  }
  toast.error(errorMessage);
};
